<div *ngIf="column.inputType === 'currency'">
  {{ displayValue | currency:'GBP':'symbol' }}
</div>
<div *ngIf="column.inputType === 'date'">
  {{ displayValue | date: 'dd/MM/yyyy' }}
</div>
<div *ngIf="column.inputType === 'datetime-local'">
  {{ displayValue | date: 'dd/MM/yyyy HH:mm' }}
</div>
<div *ngIf="column.inputType === 'checkbox'">
  {{ displayValue ? 'Yes' : 'No' }} 
</div>
<div *ngIf="column.inputType === 'percentage'">
  {{ displayValue | percent:'1.0-0' }}
</div>
<div *ngIf="!['currency', 'date', 'datetime-local', 'checkbox', 'percentage'].includes(column.inputType)">
  {{ displayValue }}
</div>
